import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { MessageBox } from "element-ui";
Vue.use(VueRouter);

import { t } from "@/languages";
import layout from "@/layout/index.vue";
import platformMap from "@/common/platformMap.js";

const routes = [
  {
    path: "/",
    component: () => import("@/views/index.vue"),
    redirect: "/apply", // 首页
    children: [
      {
        path: "/apply",
        redirect: "/apply/collection/index",
        component: layout,
        children: [
          {
            path: "/apply/collection/index",
            name: t("选品采集"),
            component: () => import("@/views/collection/index.vue"),
          },
          {
            path: "/apply/collection/log",
            name: t("采集记录"),
            component: () => import("@/views/collection/collectionLog.vue"),
          },
          {
            path: "/apply/temuSemi/productManage",
            name: t("TEMU半托产品管理"),
            redirect: "/apply/temuSemi/productManage/publish",
          },
          {
            path: "/apply/temuSemi/productManage/publish",
            name: t("刊登记录"),
            component: () => import("@/views/product-manage/publish/index.vue"),
          },
          {
            path: "/apply/temuSemi/productManage/online",
            name: t("在线商品"),
            component: () => import("@/views/product-manage/online/index.vue"),
          },
          {
            path: "/apply/temuFully/productManage",
            name: t("TEMU全托产品管理"),
            redirect: "/apply/temuFully/productManage/publish",
          },
          {
            path: "/apply/temuFully/productManage/publish",
            name: t("刊登记录"),
            component: () => import("@/views/product-manage/publish/index.vue"),
          },
          {
            path: "/apply/temuFully/productManage/online",
            name: t("在线商品"),
            component: () => import("@/views/product-manage/online/index.vue"),
          },
          // {
          //   path: "/apply/productManage",
          //   name: t("产品管理"),
          //   redirect: "/apply/productManage/publish",
          // },
          // {
          //   path: "/apply/productManage/publish",
          //   name: t("刊登记录"),
          //   component: () => import("@/views/product-manage/publish/index.vue"),
          // },
          // {
          //   path: "/apply/productManage/online",
          //   name: t("在线商品"),
          //   component: () => import("@/views/product-manage/online/index.vue"),
          // },
          {
            path: "/apply/orderManage",
            name: t("订单管理"),
            component: () => import("@/views/order-manage/index.vue"),
          },
          {
            path: "/apply/purchase",
            name: t("采购备货"),
            component: () => import("@/views/purchase/index.vue"),
          },
          {
            path: "/apply/personalManage/shopManage",
            name: t("店铺管理"),
            component: () => import("@/views/shop-manage/index.vue"),
          },
          {
            path: "/apply/crossStore",
            name: t("跨境开店"),
            component: () => import("@/views/special-page/CrossStore.vue"),
          },
          {
            path: "/apply/personalManage/toolOrder",
            name: t("工具订购"),
            component: () => import("@/views/personal-manage/tool-order/index.vue"),
          },
          {
            path: "/apply/personalManage/myOrder",
            name: t("我的订购"),
            component: () => import("@/views/personal-manage/my-order/index.vue"),
          },
          {
            path: "/apply/personalManage/supplyAccount",
            name: t("货源账号"),
            component: () => import("@/views/personal-manage/supply-account/index.vue"),
          },
          {
            path: "/apply/personalManage/logisticsManage",
            name: t("物流商管理"),
            component: () => import("@/views/personal-manage/logistics-manage/index.vue"),
          },
          {
            path: "/apply/productTemplate",
            name: t("产品模板"),
            component: () => import("@/views/product-template/index.vue"),
          }, {
            path: "/apply/temuFully/productTemplate",
            name: t("产品模板"),
            component: () => import("@/views/product-template/index.vue"),
          },
        ],
      },
      // {
      //   path: "/specialPage/crossStore",
      //   name: t("跨境开店"),
      //   component: () => import("@/views/special-page/CrossStore.vue"),
      // },
      {
        path: "/collection/index",
        name: t("选品采集"),
        component: () => import("@/views/collection/index.vue"),
      },
      {
        path: "/collection/log",
        name: t("采集记录"),
        component: () => import("@/views/collection/collectionLog.vue"),
      },
      {
        path: "/temuSemi/productManage",
        name: t("TEMU半托产品管理"),
        redirect: "/temuSemi/productManage/publish",
      },
      {
        path: "/temuSemi/productManage/publish",
        name: t("刊登记录"),
        component: () => import("@/views/product-manage/publish/index.vue"),
      },
      {
        path: "/temuSemi/productManage/online",
        name: t("在线商品"),
        component: () => import("@/views/product-manage/online/index.vue"),
      },
      {
        path: "/temuFully/productManage",
        name: t("TEMU全托产品管理"),
        redirect: "/temuFully/productManage/publish",
      },
      {
        path: "/temuFully/productManage/publish",
        name: t("刊登记录"),
        component: () => import("@/views/product-manage/publish/index.vue"),
      },
      {
        path: "/temuFully/productManage/online",
        name: t("在线商品"),
        component: () => import("@/views/product-manage/online/index.vue"),
      },
      // {
      //   path: "/productManage/publish",
      //   name: t("刊登记录"),
      //   component: () => import("@/views/product-manage/publish/index.vue"),
      // },
      // {
      //   path: "/productManage/online",
      //   name: t("在线商品"),
      //   component: () => import("@/views/product-manage/online/index.vue"),
      // },
      {
        path: "/orderManage",
        name: t("订单管理"),
        component: () => import("@/views/order-manage/index.vue"),
      },
      {
        path: "/shopManage",
        name: t("店铺管理"),
        component: () => import("@/views/shop-manage/index.vue"),
      },
      {
        path: "/purchase",
        name: t("采购备货"),
        component: () => import("@/views/purchase/index.vue"),
      },
      {
        path: "/toolOrder",
        name: t("工具订购"),
        component: () => import("@/views/personal-manage/tool-order/index.vue"),
      },
      {
        path: "/myOrder",
        name: t("我的订购"),
        component: () => import("@/views/personal-manage/my-order/index.vue"),
      },
      {
        path: "/supplyAccount",
        name: t("货源账号"),
        component: () => import("@/views/personal-manage/supply-account/index.vue"),
      },
      {
        path: "/logisticsManage",
        name: t("物流商管理"),
        component: () => import("@/views/personal-manage/logistics-manage/index.vue"),
      },
      {
        path: "/productTemplate",
        name: t("产品模板"),
        component: () => import("@/views/product-template/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash", // 使用HTML5 history模式
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (store.state.common.buildType === 'App' && (store.state.common.source === 'dld' && !store.state.common.dldId)) {
    return MessageBox.confirm(
      `您当前还未登入，请先登入【店雷达】再操作！`,
      "提示",
      {
        showCancelButton: false,
        type: "warning",
      },
    )
  }
  if (store.state.common) {
    let applyShopList = store.state.common.applyShopList;
    let platform = store.state.common.applySelected.platform;
    if (platform) {
      let platformShop = applyShopList.find((v) => v.platform === platform);
      // 判断平台授权店铺
      if (store.state.common.whitePathList.includes(to.path)) {
        return next();
      }
      if (
        !platformShop ||
        platformShop.shopList.length === 0 &&
        !["/apply/personalManage/shopManage", "/shopManage",
          "/apply/personalManage/myOrder",
          "/apply/personalManage/toolOrder",
          "/apply/personalManage/supplyAccount",
        ].includes(to.path)
      ) {
        let platformName = platformMap.find(v => v.code === platform)?.nameEn || platform;
        return MessageBox.confirm(
          `您当前还未添加【${platformName}】店铺，请先添加店铺！`,
          "提示",
          {
            confirmButtonText: "立即添加",
            cancelButtonText: "取消",
            type: "warning",
          },
        )
          .then(() => {
            next("/apply/personalManage/shopManage");
          })
          .catch(() => {
            next();
          });
      }
    }
  }
  next();
});

export default router;
